import React, { useState } from 'react';
import './Avatar.css';

const Avatar = ({ 
  name, 
  profileImage, 
  size = 'medium', 
  className = '' 
}) => {
  const [imageError, setImageError] = useState(false);
  
  const getInitials = (fullName) => {
    return fullName
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const getImageUrl = (image) => {
    if (!image) return null;
    if (image.startsWith('http')) return image;
    return `${process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000'}${image}`;
  };

  const showImage = profileImage && !imageError;
  const imageUrl = getImageUrl(profileImage);

  return (
    <div className={`avatar avatar-${size} ${className}`}>
      {showImage ? (
        <img
          src={imageUrl}
          alt={name}
          className="avatar-image"
          onError={handleImageError}
        />
      ) : (
        <span className="avatar-initials">
          {getInitials(name)}
        </span>
      )}
    </div>
  );
};

export default Avatar;